var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1106 11.0793C12.9679 11.2353 12.7743 11.3229 12.5724 11.3229C12.3706 11.3229 12.177 11.2353 12.0342 11.0793L8.00492 6.67512L3.97564 11.0793C3.90541 11.1588 3.82141 11.2222 3.72854 11.2658C3.63566 11.3094 3.53577 11.3323 3.43469 11.3333C3.33362 11.3343 3.23338 11.3132 3.13982 11.2714C3.04627 11.2295 2.96127 11.1677 2.8898 11.0896C2.81832 11.0115 2.76179 10.9186 2.72352 10.8163C2.68524 10.7141 2.66598 10.6045 2.66686 10.494C2.66774 10.3835 2.68874 10.2744 2.72863 10.1728C2.76853 10.0713 2.82652 9.9795 2.89923 9.90275L7.46672 4.91028C7.60948 4.75429 7.80307 4.66666 8.00492 4.66666C8.20678 4.66666 8.40037 4.75429 8.54312 4.91028L13.1106 9.90275C13.2533 10.0588 13.3335 10.2704 13.3335 10.491C13.3335 10.7117 13.2533 10.9233 13.1106 11.0793Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBold);
export default __webpack_public_path__ + "static/media/arrow-up-bold.e293de2cb08b2486b5e7c508f26033c3.svg";
export { ForwardRef as ReactComponent };